export default "__VITE_ASSET__296da85c__"